import i18n from 'i18next';
import { MapTriggerFunction } from '../types';

export const mapCommon: MapTriggerFunction = (triggerName, payload, dataMapper) => {
    const { appVersion, platform, deviceType } = payload;
    const { entity, app_type, platform_short, platform_type, property_ids } = dataMapper;
    const language = i18n.t('analytics.tealium.language');
    const short_language_service = i18n.t('analytics.tealium.short_language_service');
    const property_id = property_ids[`${entity}-${language}`];
    return {
        track_event_type: 'activity',
        event_trigger: triggerName,
        entity,
        app_type,
        platform_short,
        platform_type,
        language,
        short_language_service,
        property_id,
        language_service: `${entity} ${language}`,
        app_id: `${entity} ${language}: ${appVersion}`,
        ott_type: `${platform.toLowerCase()} ${deviceType.toLowerCase()}`,
    };
};
